export class KioskConfiguration {
    locationId: number = 0;
    showScheduleTab: boolean = false;
    showCheckInAppointmentTab: boolean = false;
    showSignInTab: boolean = false;
    restrictSignInCheckInOutsideHours: boolean = false;
    showAccountNumber: boolean = false;
    showPhoneNumber: boolean = false;
    showEmailAddress: boolean = false;
    showDateOfBirth: boolean = false;
    showCustomField1: boolean = false;
    mandatoryAccountNumber: boolean = false;
    mandatoryPhoneNumber: boolean = false;
    mandatoryEmailAddress: boolean = false;
    mandatoryDateOfBirth: boolean = false;
    mandatoryCustomField1: boolean = false;
    showPersonRequested: boolean = false;
    showServiceRequested: boolean = false;
    showServiceRequestedCategorized: boolean = false;
    isProductServiceSelectionMandatory: boolean = false;
    defaultNotificationGroup: number = 0;
    showSpanishSpeaker: boolean = false;
    showChangeLanguageOption: boolean = false;
    showWaitTimeHome: boolean = false;
    showVisitorsWaitingHome: boolean = false;
    showWaitTimeConfirmation: boolean = false;
    showQueuePositionConfirmation: boolean = false;
    refreshRateSeconds: number = 0;
    lastPageRefreshRateSeconds: number = 0;
    sortServiceListBy: string = '';
    fontSize: string = '';
    defaultSelectedPersonOrGroup: string = '';
    waitOption: string = '';
    waitValue: number = 0;
    localizedWelcomeTextList: any[] = [];
    localizedThankyouTextList: any[] = [];
    defaultWelcomeText: string = '';
    defaultThankYouText: string = '';
    locationName: string = '';
    showGroupRequested: boolean = false;
    makePersonGroupRequestedMadatory: boolean = false;
    showDisplayOrder: boolean = false;
    showWaitTime:boolean = false;
}